import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class MapFitService {
    private fitSubject = new BehaviorSubject<boolean>(true);
    fit$ = this.fitSubject.asObservable();

    setFit(fit: boolean): void {
        this.fitSubject.next(fit);
    }
}
